import React, { useEffect, useState, useRef } from 'react';
import nlp from "compromise";
import { useNavigate } from 'react-router-dom';
import { convoaiAPI } from "../services/apiService";
import SpeechRecognition, { 
  useSpeechRecognition,
  ListeningOptions
} from 'react-speech-recognition';

function Convoai() {
  const [wakeWordDetected, setWakeWordDetected] = useState(false);
  const [commandTranscript, setCommandTranscript] = useState('');
  const [wakeWord, setWakeWord] = useState('');
  const [foundedkeyword, setFoundedkeyword] = useState('');
  const [foundedkeyword2, setFoundedkeyword2] = useState('');
  const [count, setCount] = useState(0);
  const [isRunning, setIsRunning] = useState(false);
  const [audioUrlM, setAudioUrlM] = useState<string | null>(null);
  const [aiResponse, setAiResponse] = useState<string>(''); 
  const [loading, setLoading] = useState<boolean>(false);
  const [isAudioPlaying, setIsAudioPlaying] = useState(false);
  const [conversation, setConversation] = useState<Array<{
    question: string;
    answer: string;
  }>>([]); 
  const [trigger,setTrigger] = useState(false);
  const role = localStorage.getItem('role');
  const navigate = useNavigate();
 
  const {
    transcript,
    listening,
    resetTranscript,
    browserSupportsSpeechRecognition
  } = useSpeechRecognition();

  const isMeaningful = (text: string) => {
    if (!text || typeof text !== 'string') return false;
    
    const trimmed = text.trim();
    if (trimmed.length < 2) return false; 

    const doc = nlp(trimmed);
    
    const hasSentence = doc.sentences().length > 0;
    
    const words = doc.terms().out('array');
    const meaningfulWords = words.filter((word:any) => 
      word.length > 2 && 
      !nlp(word).has('#StopWord') && 
      !/[^a-zA-Z]/.test(word) 
    );
    
    return hasSentence || meaningfulWords.length > 0;
  };

  useEffect(() => {
    const interval = setInterval(() => {
      if (!listening && !isAudioPlaying && !loading) {
        SpeechRecognition.startListening({ continuous: true, language: 'en-US' });
      }
    }, 3000); 
  
    return () => clearInterval(interval);
  }, [listening]);
  
  async function conAI() {
    setLoading(true)
    let localCount = 0
    try {
      const response = await convoaiAPI(commandTranscript);
      const answerText = response.data.text;
      const audioData = response.data.audio;  
      if (audioData.startsWith('data:audio')) {
        setAudioUrlM(audioData); 
      } 
      else if (/^[A-Za-z0-9+/=]+$/.test(audioData)) {
        const audioUrl = `data:audio/mp3;base64,${audioData}`;
        setAudioUrlM(audioUrl);
      }
      else {
        console.error("Unsupported audio format:", audioData);
        return;
      }

      const question = answerText.split('Question:')[1].split('Answer: ')[0];
      const answer = answerText.split('Answer:')[1];
      
      if(localCount === 0){
        setConversation(prev => [
          ...prev,
          {
            question: question,
            answer: answer
          }
        ]);
        localCount = localCount + 1
      }
    } catch (error) {
      console.error("API Error:", error);
    }
    finally{
      setLoading(false)
    }
  }

  useEffect(() => {
    let timer: any;
    let localCount = 0
    if (isRunning && count < 1.5) {
      timer = setTimeout(() => setCount(count + 0.5), 500); 
    } else if (isRunning && count >= 1.5) {
      if(wakeWordDetected && trigger) {
        resetTranscript();
        const yy = isMeaningful(commandTranscript)
        if(yy){
          if(localCount === 0){
            setFoundedkeyword('')
            setFoundedkeyword2('')
            conAI();
            localCount = localCount + 1
          }
        }
      }
      setIsRunning(false); 
    }
    return () => clearTimeout(timer); 
  }, [count, isRunning]);

  useEffect(() => {
    if(role !== '1'){
        navigate(`/dashboard?page=1`);
    }
    const options: ListeningOptions = {
      continuous: true,
      language: 'en-US'
    };
    SpeechRecognition.startListening(options);

    return () => {
      SpeechRecognition.stopListening();
    };
  }, []);

  useEffect(() => {
    const lowerTranscript = transcript.toLowerCase();
    const possibleWakeWords1 = ['okay', 'yes','yeah','yep', 'no', 'who','why','will','shall','could','would', 'what',"what's",'how','where' , 'when', 'tell', 'explain', 'say','hello','hi','hai','may','specify','asking'];
    const possibleWakeWords2 = ['good morning','good night','good afternoon','good evening'];
    const transcriptWords = lowerTranscript.split(/\s+/);

    let rr = false
    let foundWakeWord = false

    if(lowerTranscript.includes('hey zoro') || lowerTranscript.includes('zoro') || lowerTranscript.includes('hey shoro') || lowerTranscript.includes('hey bro') || lowerTranscript.includes('hey sorrow') || lowerTranscript.includes('stop listening') || lowerTranscript.includes('reset the chat')){
      foundWakeWord = true
    }

    const foundedkeywordDup = transcriptWords.reverse().find(word => 
      possibleWakeWords1.some(possibleWor => possibleWor === word.toLowerCase())
    ) || '';
    setFoundedkeyword(foundedkeywordDup)


    const foundedkeyword2Dup = possibleWakeWords2.find(word => 
      lowerTranscript.includes(word)
    ) || '';
    setFoundedkeyword2(foundedkeyword2Dup)

    if (foundWakeWord) {
      setCommandTranscript('');
      if (lowerTranscript.includes('hey zoro') || lowerTranscript.includes('zoro') || lowerTranscript.includes('hey shoro') || lowerTranscript.includes('hey bro') || lowerTranscript.includes('hey sorrow')) {
        resetTranscript();
        setTrigger(true)
        rr = true
        setWakeWordDetected(true);
        setWakeWord('Hey Xoro');
      }
      if (lowerTranscript.includes('stop listening')) {
        resetTranscript();
        setCommandTranscript('');
        setTrigger(false)
        setWakeWordDetected(false);
        setWakeWord('');
        rr = false
      }
      if (lowerTranscript.includes('reset the chat')) {
        setConversation([])
        setAudioUrlM('')
        resetTranscript();
        setCommandTranscript('');
        setTrigger(false)
        setWakeWordDetected(false);
        setWakeWord('');
        rr = false
      }
    }
    if (((wakeWordDetected) && (foundedkeyword || foundedkeywordDup || foundedkeyword2 || foundedkeyword2Dup)) && transcript && (trigger || rr)) {
      let fullCommand = '';
      const str = transcript;
      const keyword = foundedkeyword

      const lowerStr = str.toLowerCase();
      const lastIndex = lowerStr.lastIndexOf(keyword.toLowerCase());

      let result;
      if (lastIndex !== -1) {
          result = str.slice(lastIndex + keyword.length).trim();
      } else {
          result = str;
      }
      fullCommand = (foundedkeyword || foundedkeyword2)+ ' ' + result;
   
      setCommandTranscript(fullCommand);
      setCount(0);
      setIsRunning(true);
    }

  }, [transcript, wakeWordDetected, resetTranscript, wakeWord, commandTranscript]);

  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (containerRef.current) {
      containerRef.current.scrollTop = containerRef.current.scrollHeight;
    }
  }, [conversation]);

  const audioRef = useRef<HTMLAudioElement | null>(null);

  useEffect(() => {
    const audioEl = audioRef.current;
  
    if (audioEl) {
      const handlePlay = () => {
        setIsAudioPlaying(true);
        SpeechRecognition.stopListening();
      };
  
      const handlePauseOrEnd = () => {
        setIsAudioPlaying(false);
        if(!loading){
          SpeechRecognition.startListening({ continuous: true, language: 'en-US' });
        }
        else{
          SpeechRecognition.stopListening();
        }
      };
  
      audioEl.addEventListener('play', handlePlay);
      audioEl.addEventListener('pause', handlePauseOrEnd);
      audioEl.addEventListener('ended', handlePauseOrEnd);
  
      return () => {
        audioEl.removeEventListener('play', handlePlay);
        audioEl.removeEventListener('pause', handlePauseOrEnd);
        audioEl.removeEventListener('ended', handlePauseOrEnd);
      };
    }
  }, [audioUrlM]);
  

  if (!browserSupportsSpeechRecognition) {
    return <div>Browser doesn't support speech recognition</div>;
  }

  return (
    <div className="p-6 max-w-3xl mx-auto">
      <h1 className="text-3xl font-bold mb-6 text-center text-blue-700">XORO AI</h1>

      <div className="mb-4 p-4 bg-gray-100 rounded shadow">
        <p><strong>Status:</strong> {isAudioPlaying ? 'Not listening,🔇 Audio Playing!!!' : listening ? '🎤 Listening...'  : '🔇 Not listening'}</p>
        {wakeWordDetected 
          ? <p className="text-yellow-600">💡 Waiting for command...</p>
          : <p className="text-blue-600">🔊 Say "Hey Xoro" to begin your chat</p>}
      </div>

      <div className="mb-4 p-4 bg-blue-50 rounded shadow">
        <h3 className="text-lg font-semibold mb-2">Current Interaction</h3>
        {commandTranscript && <p><strong>Your question:</strong> {commandTranscript}</p>}
        {aiResponse && <p><strong>AI response:</strong> {aiResponse}</p>}
      </div>

      {conversation.length > 0 && (
        <div ref={containerRef} className="mb-4 p-4 max-h-[450px] overflow-x-auto bg-white border border-gray-200 rounded shadow">
          <h3 className="text-lg font-semibold mb-3">Conversation History</h3>
          {conversation.map((item, index) => (
            <div key={index} className="mb-2 border-b pb-2">
              <p><strong>Q:</strong> {item.question}</p>
              <p><strong>A:</strong> {item.answer}</p>
            </div>
          ))}
        </div>
      )}

      {audioUrlM && (
        <div className="mb-4">
          <audio ref={audioRef} controls autoPlay src={audioUrlM} className="w-full" />
        </div>
      )}

      <button 
        onClick={() => {
          resetTranscript();
          setCommandTranscript('');
          setWakeWordDetected(false);
          setWakeWord('');
          setAiResponse('');
          setConversation([])
          setFoundedkeyword('')
          setFoundedkeyword2('')
        }}
        className="px-4 py-2 bg-red-500 text-white rounded hover:bg-red-600"
      >
        Reset Conversation
      </button>

      {loading && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
          <div className="bg-white border-2 border-blue-600 rounded px-6 py-4 flex items-center space-x-3">
            <div className="w-4 h-4 border-4 border-blue-600 border-t-transparent rounded-full animate-spin"></div>
            <p className="text-blue-700">Getting Response...</p>
          </div>
        </div>
      )}
    </div>
  );
}

export default Convoai;

